import { post, postpro } from '../index';


export const verifyProjectNumber = data => {
    return postpro('/projects/verify-project-number', data, false);
  };